
import React from 'react';
import AestheticFilter from './AestheticFilter';
import { FilterCategory } from './types';

interface MapControlsProps {
  filteredDevicesCount: number;
  consumersCount: number;
  showDevices: boolean;
  showConsumers: boolean;
  setShowDevices: (show: boolean) => void;
  setShowConsumers: (show: boolean) => void;
  filterCategories: FilterCategory[];
  activeFilters: Record<string, string[]>;
  onFilterChange: (category: string, value: string) => void;
  onClearFilters: () => void;
}

const MapControls: React.FC<MapControlsProps> = (props) => {
  return (
    <AestheticFilter {...props} />
  );
};

export default MapControls;
